import script from "./SealsCertificatesEngraving.vue?vue&type=script&setup=true&lang=ts"
export * from "./SealsCertificatesEngraving.vue?vue&type=script&setup=true&lang=ts"

import "./SealsCertificatesEngraving.vue?vue&type=style&index=0&id=c9758302&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9758302"]])

export default __exports__